import { usersApi } from 'entities/users';
import { CountriesType } from 'entities/distribution/types';

type countriesParamsType = {
  id: number;
};

const getCountriesApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<CountriesType[], null>({
      query: () => '/account/admin/dicts/countries/',
    }),
    getCountriesById: builder.query<CountriesType, countriesParamsType>({
      query: ({ id }) => `/account/admin/dicts/countries/${id}`,
    }),
  }),
});

export const { useGetCountriesQuery, useGetCountriesByIdQuery } = getCountriesApi;
